import React from 'react';
import ReactDOM from 'react-dom';
import UserResetPassword from 'ResetPassword.jsx';


ReactDOM.render(
    <UserResetPassword />,
    document.getElementById('content')
);


// WEBPACK FOOTER //
// ./src/Standard/ResetPassword.js